import { DeleteModal, ModalContext } from 'dash-ui';
import { useContext } from 'react';

import { ExternalSalesModalKeys } from 'pages/external-sales/constants/constants';
import {
  GetSaleTeamUsersDocument,
  SaleTeamUser,
  useDeleteSaleTeamUserMutation,
} from 'gql/generated.graphql';

const DeleteSaleTeamUserModal = () => {
  const { payload } = useContext(ModalContext);

  const [deleteSaleTeamUser, { loading }] = useDeleteSaleTeamUserMutation({
    refetchQueries: [GetSaleTeamUsersDocument],
  });

  const onSubmit = async () => {
    const { _id: saleTeamUserId, saleTeamId } = payload as SaleTeamUser;

    await deleteSaleTeamUser({
      variables: { saleTeamId, saleTeamUserId },
    });
  };

  return (
    <DeleteModal
      entity="Sale Team"
      name={`${payload?.profile?.firstName} ${payload?.profile?.lastName}`}
      isLoading={loading}
      modalName={ExternalSalesModalKeys.DeleteSaleTeamUser}
      onClick={onSubmit}
      colorVariation="danger"
    />
  );
};

export default DeleteSaleTeamUserModal;
